import React from 'react';
import '../css/App.css';
import '../css/BotNav.css';
import ls from 'local-storage'
import { withRouter } from 'react-router'


class BotNav extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            navItems:[
                {
                    en:"report",
                    title:"گزارشات",
                    img:"btmreport.png",
                    url:"/reports",
                    active:"btmreport_active.png",
                },
                {
                    en:"fav",
                    title:"خدمات",
                    img:"services.svg",
                    url:"/services",
                    active:"services_active.svg",
                },
                {
                    en:"home",
                    title:"صفحه اصلی",
                    img:"home.png",
                    url:"/home",
                    active:"home_active.png",
                },
                {
                    en:"search",
                    title:"جست و جو",
                    img:"search.png",
                    url:"/search",
                    active:"search_active.png",
                },
                {
                    en:"cart",
                    title:"سبد خرید",
                    img:"btmcart.png",
                    url:"/cart",
                    active:"btmcart_active.png",
                }
            ],
            buy_list:[],
        };

        this.handleBotNav = this.handleBotNav.bind(this);

    }
    componentWillReceiveProps(props) {
        if(props.productsList != null)
            this.setState(
                {buy_list:props.productsList})
    }

    componentDidMount() {
        this.setState({buy_list:ls.get("list")})
    }

    render() {
        return (
            <div className={"botNav"}>
                {this.generateItems()}
            </div>
        );
    }


    handleBotNav = (index) => {
        console.log("index : ",index);
        this.props.history.push(this.state.navItems[index]['url']);
    };

    generateItems(){
        return this.state.navItems.map((data,index)=>{
            let counter = "";
            if(data.en === "cart" && this.state.buy_list!=null && this.state.buy_list.length > 0){
                counter = (<div className={"cart_counter"}>{this.state.buy_list.length}</div>);
            }
            return (
                <div className={"botNavItem "+((this.props.location.pathname === data["url"])?"active":"")} onClick={()=>this.handleBotNav(index)}>
                    <img className={"botNavImg"} src={`${process.env.PUBLIC_URL}/assets/images/`+((this.props.location.pathname === data["url"])?data['active']:data['img'])}/>
                    {counter}
                    <div className={"botNavTex"}>{data['title']}</div>
                </div>
            );
        })
    }
}



export default withRouter(BotNav);
